<template>
  <div class="partner">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>
        <el-radio v-model="radio" label="区域查询" class="x-m-l-5 x-m-r-20" @change="fHeadRadioChange">区域查询</el-radio>
        <!-- <el-cascader
          size="medium"
          :options="sortOptions"
          v-model="searchSortVal"
          @change="fHeadSortChange"
          style="width: 160px"
          class="x-m-r-2 x-m-l-5"
        ></el-cascader> -->
        <!-- <el-cascader
          v-if="radio == '区域查询'"
          size="medium"
          :options="[
            { label: '商户', value: '商户' },
            { label: '代理商', value: '代理商' },
          ]"
          v-model="searchTypeVal"
          @change="fHeadTypeChange"
          style="width: 100px"
          class="x-m-r-2"
        ></el-cascader> -->
        <el-cascader clearable v-if="radio == '区域查询'" size="medium" separator="-" placeholder="区域查询（可选）"
          :options="addrOptions" :props="{ checkStrictly: true }" @change="fHeadAddressChange"
          v-model="searchAddressVal" class="x-m-r-15"></el-cascader>
        <el-button size="medium" type="primary" @click="nowPage=1;init()" v-if="radio == '区域查询'" class="x-m-r-15">查询
        </el-button>
        <el-input v-if="radio == '条件查询'" placeholder="手机号 联系人 公司名查询" v-model="merInputVal" size="medium"
          style="width: 300px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>
          <!-- <template slot="append">搜索</template> -->
        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <!-- <el-button size="medium" type="primary">区域查找</el-button> -->
        <!-- <el-button size="medium" type="danger">清空</el-button> -->
      </div>
      <div class="x-flex" v-if="can_add_sub_yn == 'Y'">
        <el-button type="danger" size="medium" @click="fRegPartner">增加代理</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == item.sortType && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == item.sortType && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <!-- <vxe-column field="endLoginTime" title="最后登录时间" width="150">
          </vxe-column> -->
          <!-- <vxe-column field="partner_soft_price" title="合作价格" width="80"> </vxe-column> -->
          <vxe-column v-if="
              bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
            " field="partner_soft_price" title="分润基数" width="110">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('partner_soft_price', 'asc')">
                <span>分润基数</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == 'partner_soft_price' && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == 'partner_soft_price' && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column v-if="
              bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
            " field="partner_soft_tc_value" title="分润系数" width="110">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('partner_soft_tc_value', 'asc')">
                <span>分润系数</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == 'partner_soft_tc_value' &&
                      sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == 'partner_soft_tc_value' &&
                      sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column fixed="right" title="操作"
            :width="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'?180:120" style="margin-bottom: 20px"
            v-if="can_add_sub_yn == 'Y'">
            <template slot-scope="scope">
              <div class="x-flex x-row-around">
                <!-- <el-button type="text" size="mini" @click="fShowJfMb" class="x-m-l-4 x-m-r-10" style="color: #2c8ff2">
                  计费模板
                </el-button> -->
                <el-button type="text" size="mini" @click="frPop = true;frInfo=scope.row" class="x-m-l-10 x-m-r-4"
                  style="color: #2c8ff2" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
                  分润结算
                </el-button>
                <el-button type="text" size="mini" @click="fAsideChoose('/orgFrMx',scope.row)" class="x-m-l-4 x-m-r-4"
                  style="color: #2c8ff2" v-if="showFrGl">
                  查看分润
                </el-button>
                <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-l-4 x-m-r-10"
                  style="color: #2c8ff2">
                  修改
                </el-button>
              </div>

            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-size="20" :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditAgent" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="8vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">
          {{ partnerAddOrEdit == "ADD" ? "增加代理" : "修改代理" }}
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSavePartner">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <div class="x-flex x-p-l-10 x-bd-bottom x-m-b-5 c-80">
        <div class='x-flex x-h40 x-cur-poi x-m-r-20' :class='active=="基本信息"?"active-title":""' @click='active="基本信息"'>
          基本信息
        </div>
        <div class='x-flex x-h40 x-cur-poi x-m-r-20' v-if="showAuth" :class='active=="权限管理"?"active-title":""'
          @click='active="权限管理"'>
          权限管理
        </div>
        <div class='x-flex x-h40 x-cur-poi x-m-r-20' v-if="showPay" :class='active=="支付方式"?"active-title":""'
          @click='active="支付方式"'>
          支付方式
        </div>
        <div class='x-flex x-h40 x-cur-poi x-m-r-20'
          v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098' && parInfo.partner_soft_fr_yn"
          :class='active=="分润设置"?"active-title":""' @click='active="分润设置"'>
          分润设置
        </div>

      </div>
      <div v-if="active == '基本信息'">

        <!-- 手机号  联系人  登录密码  -->
        <el-row class="x-m-t-15">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 must">手机号</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.parPhone" type="number"
              :disabled="partnerAddOrEdit == 'EDIT' ? true : false"></el-input>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 must">联系人</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.lxName"></el-input>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 must">登录密码</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.loginPwd"></el-input>
          </el-col>
        </el-row>
        <!-- 公司名  服务器地址 -->
        <el-row class="x-m-t-15">
          <el-col class="x-flex" :span="this.loaclSess.phone == '18957102098' ? 16 : 24">
            <div class="x-w90 x-text-r x-p-r-15 must">公司名</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.companyName"></el-input>
          </el-col>
          <el-col class="x-flex" :span="8" v-if="this.loaclSess.phone == '18957102098'">
            <div class="x-w90 x-text-r x-p-r-15 must x-font-13">服务器地址</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.serverIp"></el-input>
          </el-col>
          <!-- <el-col class="x-flex" :span="8">
          <div class="x-w110 x-text-r x-p-r-15">可注册用户数</div>
          <el-input
            size="small"
            class="x-flex-1"
            v-model="parInfo.regNum"
          ></el-input>
        </el-col> -->
        </el-row>
        <!-- 所属行业  主要经营 -->
        <el-row class="x-m-t-15">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 must">所属行业</div>
            <!-- <el-cascader
            size="small"
            class="x-flex-1"
            :options="industryOptions"
            v-model="parInfo.industry"
            @change="fIndustryChange"
          ></el-cascader> -->
            <el-input size="small" class="x-flex-1" v-model="parInfo.industry"></el-input>
          </el-col>
          <el-col class="x-flex" :span="16">
            <div class="x-w90 x-text-r x-p-r-15 must">主要经营</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.mainSale"></el-input>
          </el-col>
        </el-row>
        <!-- 区域选择  详细地址 -->
        <el-row class="x-m-t-15">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 must">门店地址</div>
            <el-cascader size="small" separator="-" class="x-flex-1" :options="addrOptions" @change="fAddrChange"
              v-model="parInfo.address"></el-cascader>
          </el-col>
          <el-col class="x-flex" :span="16">
            <div class="x-w90 x-text-r x-p-r-15 must">详细地址</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.addrDetail"></el-input>
          </el-col>
        </el-row>
        <!-- 备注 -->
        <el-row class="x-m-t-15">
          <el-col class="x-flex" :span="24">
            <div class="x-w90 x-text-r x-p-r-15">备注信息</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.remarks"></el-input>
          </el-col>
        </el-row>
        <!-- 合作方式  代理等级  代理费用 -->
        <el-row class="x-m-t-15" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">合作方式</div>
            <!-- <el-input
            size="small"
            class="x-flex-1"
            v-model="parInfo.cooType"
          ></el-input> -->
            <el-cascader size="small" class="x-flex-1" :options="cooTypeOptions" @change="
              (e) => {
                fCascaderChange(e, 'cooType');
              }
            " v-model="parInfo.cooType"></el-cascader>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">代理等级</div>
            <el-cascader size="small" class="x-flex-1" :options="agentGradeOptions" @change="
              (e) => {
                fCascaderChange(e, 'agentGrade');
              }
            " v-model="parInfo.agentGrade"></el-cascader>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">代理费用</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.agentCost"></el-input>
          </el-col>
        </el-row>
        <!-- 可注册用户数  失效时间  状态 -->
        <el-row class="x-m-t-15" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15 x-font-12">可注册用户</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.regNum"></el-input>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">失效时间</div>
            <el-date-picker size="small" class="x-flex-1" v-model="parInfo.expireTime" type="date" placeholder="选择日期"
              :clearable="false" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">当前状态</div>
            <el-cascader size="small" class="x-flex-1" :options="stateOptions" @change="
              (e) => {
                fCascaderChange(e, 'state');
              }
            " v-model="parInfo.state"></el-cascader>
          </el-col>
        </el-row>
        <!-- 提成方式  提成基数  提成值 -->
        <el-row class="x-m-t-15" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">续费分佣</div>
            <el-cascader size="small" class="x-flex-1" :options="comTypeOptions" @change="
              (e) => {
                fCascaderChange(e, 'comType');
              }
            " v-model="parInfo.comType"></el-cascader>
          </el-col>
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">分佣系数</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.comValue" min="0" max="100" type="number"
              @change="fComValueChange">
              <template slot="append" v-if="parInfo.comType == '按比例值'">%</template>
            </el-input>

          </el-col>
          <el-col class="x-flex x-m-t-8" :span="8" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <!-- <div class="x-p-l-20 " style="color: #808080">
              商店增值服务勾选商店分润后生效,分佣方式请到商店商品设置
            </div> -->
            <el-checkbox class="x-m-l-20" v-model="parInfo.isFree">显示续费二维码</el-checkbox>
            <el-checkbox v-model="parInfo.editTime">修改到期时间</el-checkbox>
            <!-- <div class="x-w90 x-text-r x-p-r-15">分佣基数</div>
          <el-input size="small" class="x-flex-1" v-model="parInfo.comBase" :disabled="parInfo.comType == '按比例值'">
          </el-input> -->
          </el-col>

        </el-row>
        <!-- 可增门店数  是否OEM  是否免费 -->
        <el-row class="x-m-t-15" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
          <el-col class="x-flex" :span="24">
            <div class="x-w90 x-text-r x-p-r-15"></div>
            <el-checkbox v-model="parInfo.partner_soft_fr_yn">商店分润</el-checkbox>
            <el-checkbox v-model="parInfo.shop_show_payqr_yn">商店显示收款二维码</el-checkbox>
            <el-checkbox v-model="parInfo.addMallNum">可增门店</el-checkbox>
            <el-checkbox v-model="parInfo.isOem">OEM</el-checkbox>
            <el-checkbox v-model="parInfo.addSub">可增下级代理</el-checkbox>
            <!-- <el-checkbox v-model="parInfo.editSub">修改下级代理</el-checkbox> -->
            <!-- <el-cascader size="small" class="x-flex-1" :options="YNOptions" @change="
              (e) => {
                fCascaderChange(e, 'addMallNum');
              }
            " v-model="parInfo.addMallNum"></el-cascader> -->
          </el-col>
          <!-- <el-col class="x-flex" :span="8">
          <div class="x-w90 x-text-r x-p-r-15">是否OEM</div>
          <el-cascader :disabled="this.loaclSess.phone != '18957102098'" size="small" class="x-flex-1"
            :options="YNOptions" @change="
              (e) => {
                fCascaderChange(e, 'isOem');
              }
            " v-model="parInfo.isOem"></el-cascader>
        </el-col> -->
          <!-- <el-col class="x-flex" :span="8">
          <div class="x-w90 x-text-r x-p-r-15">是否免费</div>
          <el-cascader :disabled="this.loaclSess.phone != '18957102098'" size="small" class="x-flex-1"
            :options="YNOptions" @change="
              (e) => {
                fCascaderChange(e, 'isFree');
              }
            " v-model="parInfo.isFree"></el-cascader>
        </el-col> -->
        </el-row>
        <!-- 修改时间  主页网址 -->
        <el-row class="x-m-t-15">
          <!-- <el-col class="x-flex" :span="8">
          <div class="x-w90 x-text-r x-p-r-15">可修改时间</div>
          <el-cascader size="small" class="x-flex-1" :options="YNOptions" @change="
              (e) => {
                fCascaderChange(e, 'editTime');
              }
            " v-model="parInfo.editTime"></el-cascader>

        </el-col> -->
          <el-col class="x-flex" :span="24">
            <div class="x-w90 x-text-r x-p-r-15">主页网址</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.homeUrl"></el-input>
          </el-col>
        </el-row>
        <!-- 自定义模块  自定义模块网址  自定义模块独立打开浏览器 -->
        <el-row class="x-m-t-15 x-p-b-20">
          <el-col class="x-flex" :span="8">
            <div class="x-w90 x-text-r x-p-r-15">自定义模块</div>
            <el-input size="small" class="x-flex-1" v-model="parInfo.customModule"></el-input>
          </el-col>
          <el-col class="x-flex x-p-l-10" :span="10">
            <el-input size="small" class="x-flex-1" v-model="parInfo.customMOduleUrl" placeholder="自定义模块网址"></el-input>
          </el-col>
          <el-col class="x-flex x-col-center x-p-l-10" style="height: 32px" :span="6">
            <el-checkbox v-model="parInfo.customMOduleAlsoOpenBrowser">自定义模块独立打开浏览器</el-checkbox>
          </el-col>
        </el-row>
      </div>
      <div v-if="active == '权限管理'">
        <!-- <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">权限管理</div>
        </div> -->
        <el-row class="x-p-t-20 x-p-b-30">
          <el-col class="x-flex x-col-start" :span="24">
            <el-checkbox-group class="x-flex-1" v-model="checkAdministrationList">
              <!-- <el-checkbox class='x-p-t-10 x-w110' label="新增下级代理"></el-checkbox> -->
              <!-- <el-checkbox class='x-p-t-10 x-w110' label="修改下级代理"></el-checkbox> -->
              <el-checkbox class='x-p-t-10 x-w110' label="清除所有数据"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="客户端版本推送"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="电子价签"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="权限管理"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="支付方式管理"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="产品码库"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="产品码库新增"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="产品码库修改"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="产品码库划拨"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="微信设置"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="人脸识别"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="AI商户库"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="AI机构号"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="消息管理"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="商店订单"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="外卖商户"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="抖音商户"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="分润管理"></el-checkbox>
              <el-checkbox class='x-p-t-10 x-w110' label="分润明细"></el-checkbox>
              <!-- <el-checkbox class='x-p-t-10 x-w110' label="分润结算"></el-checkbox> -->
              <el-checkbox class='x-p-t-10 x-w110' label="加盟门店"></el-checkbox>
              <!-- <el-checkbox class='x-p-t-10 x-w110' label="商户支付"></el-checkbox> -->

            </el-checkbox-group>
          </el-col>
        </el-row>
      </div>
      <div v-if="active == '支付方式'">
        <!-- <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">支付方式</div>
        </div> -->
        <el-row class="x-p-t-20 x-p-b-30">
          <el-col class="x-flex x-col-start" :span="24">
            <el-checkbox-group class="x-flex-1" v-model="checkPayWayList">
              <el-checkbox class='x-p-t-10 x-w110' :label="item.label" v-for="item in payWayOptions" :key="item.lable">
              </el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </div>
      <div v-if="active == '分润设置'" class="" style="height: 540px;width: 100%;">
        <!-- <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">分润设置</div>
        </div> -->
        <vxe-table highlight-hover-row height="95%" :data="frTableData" align="center"
          :edit-config="{trigger: 'click', mode: 'cell', icon: 'vxe-icon-edit'}">
          <!-- <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column> -->
          <vxe-column :field="item.sortType" :title="item.title" :min-width="item.width" v-for="item in frTableJson"
            :key="item.id">
          </vxe-column>
          <vxe-column field="ledger_way" title="分润方式" min-width="100" :edit-render="{autofocus: '.el-input__inner'}">
            <template #default="{ row }">
              <!-- <el-cascader size="small" class="x-flex-1" :options="comTypeOptions" @change="
                (e) => {
                  fCascaderChange(e, 'frComType',rowIndex);
                }
              " v-model="row.ledger_way"></el-cascader> -->
              <el-select class="x-w100p" ref="select" v-model="row.ledger_way" @change="row.ledger_value = 0">
                <el-option v-for="item in comTypeOptions" :key="item.RC" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </vxe-column>
          <vxe-column field="ledger_value" title="分润系数" min-width="100" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-input v-model="row.ledger_value" v-if="row.ledger_way =='按比例值'"
                oninput="if(value){value=value.replace(/[^\d.]/g, '');if(Number(value)<=0){value=0}} if(Number(value)>100){value=100}"
                max="100" min="0" type="number">
              </el-input>
              <el-input v-model="row.ledger_value" v-else max="100" min="0" type="number">
              </el-input>
            </template>
          </vxe-column>




        </vxe-table>
      </div>

    </el-dialog>
    <!-- 计费模板 -->
    <el-dialog :visible.sync="jfMbPop" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="8vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">
          计费模板<span style='font-size: 14px;color: #808080;'>（新增SAAS商户时商家默认计费）</span>
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSaveJfMb">保存</el-button>
          <el-button type="info" size="small" @click="jfMbPop=false">关闭</el-button>
        </div>
      </div>
      <div>
        <vxe-table border resizable highlight-hover-row height="500px" :data="mallXfData" align="center" ref="xTable1"
          style="width: 100%;">
          <vxe-column field="size_name" min-width='90px' title="功能模板"></vxe-column>
          <vxe-column field="num" min-width='120px' title="包年续费/元" :edit-render="{autofocus: '.el-input__inner'}">
            <template slot-scope="scope">
              <div class="f600 c-cz">{{scope.row.num}}</div>
            </template>
            <template #edit="{ row ,rowIndex ,column}">
              <div class='numInput'>
                <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                </el-input>
              </div>
            </template>
          </vxe-column>
          <vxe-column field="pro_create_time" title="包年到期时间" min-width='160px'
            :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row ,rowIndex ,column}">
              <el-date-picker style='width:100%' v-model="row.pro_create_time" type="date" format='yyyy-MM-dd'
                value-format='yyyy-MM-dd' placeholder="选择包年到期时间" :clearable='true'>
              </el-date-picker>
            </template>
          </vxe-column>
          <vxe-column field="num" min-width='80px' title="终身买断/元" :edit-render="{autofocus: '.el-input__inner'}">
            <template slot-scope="scope">
              <div class="f600 c-cz">{{scope.row.num}}</div>
            </template>
            <template #edit="{ row ,rowIndex ,column}">
              <div class='numInput'>
                <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                </el-input>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="frPop" width="600px"  :show-close="false" :close-on-click-modal="false" class="">
      <div class="x-bd-bottom x-flex x-row-between x-p-b-10">
        <div class="x-font-15 f600 ">
          分润结算
        </div>
        <div class="x-flex ">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;" @click="fClose"></i>
        </div>
        <!-- <div class="x-flex">
          <el-button type="danger" size="small" @click="fSave">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div> -->
      </div>
      <el-row class="x-p-t-40" :gutter="20">
        <el-col class="x-flex" :span="24">
          <div class="x-w70">服务商名</div>
          {{frInfo.comp_name}} ({{frInfo.user_phone}})
        </el-col>

      </el-row>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">未结金额</div>
          <div class="x-lh-32 x-font-20" style="color: #F56C6C;">
            {{frInfo.soft_fr_now_money}}
          </div>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w70">本次结算</div>

          <el-input class="x-flex-1" v-model="frInfo.money" size="small" >
            <span slot="append">元</span>
          </el-input>
        </el-col>
      </el-row>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="24">
          <div class="x-w70">结算备注</div>
          <el-input class="x-flex-1" v-model="frInfo.remark" size="small"></el-input>
        </el-col>
      </el-row>
      <div class="x-text-r x-p-t-30">
        <el-button type="danger" size="small" @click="fSaveJs">确认结算</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import adr from "../assets/js/adr.js";
  export default {
    data() {
      return {
        loaclSess: {
          phone: "",
        },
        active: '基本信息',
        checkAdministrationList: [],
        checkPayWayList: [],
        can_add_sub_yn: "", // 是否拥有新增/修改下级代理的权限
        serverIp: "", // 默认 服务器 IP
        shen: "",
        shi: "",
        qu: "",
        radio: "条件查询",
        merInputVal: "",
        searchAddressVal: "", //
        // searchTypeVal: "商户", //
        // searchSortVal: "已注册数降序", //
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        // sortOptions: [
        //   {
        //     label: "已注册数降序",
        //     value: "已注册数降序",
        //   },
        //   {
        //     label: "到期时间降序",
        //     value: "到期时间降序",
        //   },
        //   {
        //     label: "支付分润降序",
        //     value: "支付分润降序",
        //   },
        //   {
        //     label: "软件分润降序",
        //     value: "软件分润降序",
        //   },
        //   {
        //     label: "最后注册时间降序",
        //     value: "最后注册时间降序",
        //   },
        //   {
        //     label: "等级降序",
        //     value: "等级降序",
        //   },
        //   {
        //     label: "上级降序",
        //     value: "上级降序",
        //   },
        //   {
        //     label: "今日活跃降序",
        //     value: "今日活跃降序",
        //   },
        //   {
        //     label: "七日活跃降序",
        //     value: "七日活跃降序",
        //   },
        //   {
        //     label: "已注册数升序",
        //     value: "已注册数升序",
        //   },
        //   {
        //     label: "到期时间升序",
        //     value: "到期时间升序",
        //   },
        //   {
        //     label: "支付分润升序",
        //     value: "支付分润升序",
        //   },
        //   {
        //     label: "软件分润升序",
        //     value: "软件分润升序",
        //   },
        //   {
        //     label: "最后注册时间升序",
        //     value: "最后注册时间升序",
        //   },
        //   {
        //     label: "等级升序",
        //     value: "等级升序",
        //   },
        //   {
        //     label: "上级升序",
        //     value: "上级升序",
        //   },
        //   {
        //     label: "今日活跃升序",
        //     value: "今日活跃升序",
        //   },
        //   {
        //     label: "七日活跃升序",
        //     value: "七日活跃升序",
        //   },
        // ],
        payWayOptions: [
          // {
          //   label: "贝友PAY",
          //   value: "贝友PAY",
          // },
          // {
          //   label: "乐刷",
          //   value: "乐刷",
          // },

         {
           label: "尚米PAY",
           value: "尚米PAY",
         }, {
            label: "嘉联支付",
            value: "嘉联支付",
          },

          {
            label: "银商支付",
            value: "银商支付",
          },
          {
            label: "拉卡拉",
            value: "拉卡拉",
          },
          {
            label: "京东支付",
            value: "京东支付",
          },
          {
            label: "河马付",
            value: "河马付",
          },
          {
            label: "信联付",
            value: "信联付",
          },
          {
            label: "平安银行",
            value: "平安银行",
          },
          {
            label: "中国银联",
            value: "中国银联",
          },
          {
            label: "微邮付",
            value: "微邮付",
          },
          {
            label: "付呗",
            value: "付呗",
          },
          {
            label: "随行付",
            value: "随行付",
          },
          {
            label: "汇付斗拱",
            value: "汇付斗拱",
          },
          {
            label: "阿里云支付",
            value: "阿里云支付",
          },
          {
            label: "盒子",
            value: "盒子",
          },
          {
            label: "东之付",
            value: "东之付",
          },
          {
            label: "德宏农行付",
            value: "德宏农行付",
          },

          {
            label: "陕西信合",
            value: "陕西信合",
          },
          {
            label: "其他支付",
            value: "其他支付",
          },
        ],
        addrOptions: adr.adr,
        tableData: [],
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        tableJson: [{
            // 循环渲染数据
            id: 2,
            title: "等级",
            width: "80",
            sortType: "partner_level",
          },
          {
            id: 3,
            title: "手机号",
            width: "110",
            sortType: "user_phone",
          },
          {
            id: 4,
            title: "公司名",
            width: "200",
            sortType: "comp_name",
          },
          {
            id: 5,
            title: "联系人",
            width: "200",
            sortType: "user_name",
          },
          {
            id: 6,
            title: "总门店数",
            width: "100",
            sortType: "reg_user_num",
          },
          {
            id: 7,
            title: "今日活跃",
            width: "100",
            sortType: "day1_act_sh_count",
          },
          {
            id: 8,
            title: "七日活跃",
            width: "100",
            sortType: "day7_act_sh_count",
          },
          {
            id: 9,
            title: "可注册数",
            width: "100",
            sortType: "can_reg_user_num",
          },
          {
            id: 10,
            title: "省",
            width: "80",
            sortType: "shen",
          },
          {
            id: 11,
            title: "市",
            width: "80",
            sortType: "shi",
          },
          {
            id: 12,
            title: "区",
            width: "80",
            sortType: "qu",
          },
          {
            id: 13,
            title: "地址",
            width: "250",
            sortType: "comp_address",
          },
          {
            id: 14,
            title: "上级",
            width: "100",
            sortType: "p_user_name",
          },
          {
            id: 15,
            title: "上级公司",
            width: "200",
            sortType: "p_comp_name",
          },
          {
            id: 16,
            title: "最后注册时间",
            width: "170",
            sortType: "last_reg_time",
          },
          {
            id: 17,
            title: "剩余天数",
            width: "100",
            sortType: "stop_day",
          },
          {
            id: 18,
            title: "到期时间",
            width: "150",
            sortType: "stop_time",
          },
          {
            id: 19,
            title: "支付分润",
            width: "100",
            sortType: "partner_zf_fr_yn",
          },
          {
            id: 20,
            title: "支付总分润",
            width: "120",
            sortType: "zf_fr_total_money",
          },
          {
            id: 21,
            title: "支付未结分润",
            width: "130",
            sortType: "zf_fr_now_money",
          },
          {
            id: 22,
            title: "软件分润",
            width: "100",
            sortType: "partner_soft_fr_yn",
          },
          {
            id: 23,
            title: "软件总分润",
            width: "130",
            sortType: "soft_fr_total_money",
          },
          {
            id: 24,
            title: "软件未结分润",
            width: "130",
            sortType: "soft_fr_now_money",
          },
          {
            id: 25,
            title: "分润方式",
            width: "100",
            sortType: "partner_soft_tc_way",
          },
        ],
        frTableData: [],
        frTableJson: [{
            id: 1,
            title: "商店编码",
            width: "140",
            sortType: "shop_id",
          },
          // {
          //   id: 2,
          //   title: "商店名称",
          //   width: "140",
          //   sortType: "pro_name",
          // },
          {
            id: 3,
            title: "产品编码",
            width: "140",
            sortType: "pro_id",
          },
          {
            id: 4,
            title: "产品名称",
            width: "140",
            sortType: "pro_name",
          },
          // {
          //   id: 5,
          //   title: "分润方式",
          //   width: "100",
          //   sortType: "ledger_way",
          // },
          // {
          //   id: 6,
          //   title: "分润系数",
          //   width: "100",
          //   sortType: "ledger_value",
          // },
        ],
        addOrEditAgent: false, // 增加/修改代理
        partnerAddOrEdit: "ADD",
        parInfo: {
          parPhone: "", // 手机号
          lxName: "", // 联系人
          loginPwd: "", // 登录密码

          companyName: "", // 公司名
          serverIp: "", // 服务器地址

          industry: "", // 所属行业
          mainSale: "", // 主要经营

          address: [], // 门店地址
          addrDetail: "", // 详细地址

          remarks: "", // 备注

          cooType: "按店付费", // 合作方式
          agentGrade: "D", // 代理等级
          agentCost: 39800, // 代理费用

          regNum: '0', // 可注册用户数
          expireTime: this.bykApi.timeHelper.manyDaysLater(365), // 失效时间
          state: "正常", // 状态

          comBase: '0', // 提成基数
          comType: "按比例值", // 提成方式
          comValue: '0', // 提成值

          addSub: false, // 是否可增下级
          addMallNum: false, // 是否可增门店
          isOem: false, // 是否OEM
          isFree: true, // 是否免费
          partner_soft_fr_yn: false,
          shop_show_payqr_yn: false,
          editTime: false, // 是否修改时间
          homeUrl: "http://www.sanmipos.com", // 主页网址

          customModule: "", // 自定义模块
          customMOduleUrl: "", // 自定义模块网址
          customMOduleAlsoOpenBrowser: false, // 自定义模块独立打开浏览器
        },
        // 所属行业列表
        // industryOptions: [
        //   {
        //     label: "IT",
        //     value: "IT",
        //   },
        // ],
        // 状态列表
        stateOptions: [{
            label: "正常",
            value: "正常",
          },
          {
            label: "删除",
            value: "删除",
          },
        ],
        // 提成方式列表
        comTypeOptions: [{
            label: "按固定值",
            value: "按固定值",
          },
          {
            label: "按比例值",
            value: "按比例值",
          },
        ],
        // OEM 列表   是否免费
        YNOptions: [{
            label: "是",
            value: "是",
          },
          {
            label: "否",
            value: "否",
          },
        ],
        // 合作方式列表
        cooTypeOptions: [{
            label: "按店付费",
            value: "按店付费",
          },
          {
            label: "包年服务",
            value: "包年服务",
          },
        ],
        // 代理等级 列表
        agentGradeOptions: [{
            label: "A",
            value: "A",
          },
          {
            label: "B",
            value: "B",
          },
          {
            label: "C",
            value: "C",
          },
          {
            label: "D",
            value: "D",
          },
        ],
        jfMbPop: false,
        mallXfData: {},
        showAuth: false,
        showPay: false,
        showXzXjDl: false,
        showXgXjDl: false,
        showFrGl: false,
        frPop: false,
        frInfo:{}
      };
    },
    async created() {

      this.showPay = await this.bykApi.global.fGetSmMenuQx('支付方式管理')
      this.showAuth = await this.bykApi.global.fGetSmMenuQx('权限管理')
      // this.showXzXjDl = await this.bykApi.global.fGetSmMenuQx('新增下级代理')
      // this.showXgXjDl = await this.bykApi.global.fGetSmMenuQx('修改下级代理')
      this.showFrGl = await this.bykApi.global.fGetSmMenuQx('分润管理')
      console.log(this.showPay, this.showAuth)
      // if (this.bykApi.smCom.fSmIsEmpty(this.bykApi.global.fGetPlatform().partnerInfo.data.auth_info)) {
      //   let authArr = JSON.parse(this.bykApi.global.fGetPlatform().partnerInfo.data.auth_info);
      //   let idx = authArr.findIndex(item => {
      //     return item == '支付方式管理'
      //   })
      //   if (idx != -1) {
      //     this.showPay = true
      //   } else {
      //     this.showPay = false
      //   }
      //   let idx1 = authArr.findIndex(item => {
      //     return item == '权限管理'
      //   })
      //   if (idx1 != -1) {
      //     this.showAuth = true
      //   } else {
      //     this.showAuth = false
      //   }
      // }
      // if (JSON.parse(localStorage.bykPlatform).partnerInfo.data.user_phone == '18957102098') {
      //   this.showPay = true
      //   this.showAuth = true
      // }
      this.init();
    },
    methods: {

      async init() {
        let localJson = localStorage.getItem("bykPlatform");
        this.loaclSess.phone = JSON.parse(localJson).partnerInfo.data.user_phone;
        let res = await this.fBykGetSubPartnerInfo(
          "PARTNER_LIST",
          this.merInputVal
        );

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.can_add_sub_yn = res.can_add_sub_yn;
        this.serverIp = res.fwq_ip;
        this.parInfo.serverIp = res.fwq_ip;
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = res.data[0].TR;
          this.TP = res.data[0].TP;
        }
        this.tableData = res.data;
      },

      async fModify(row) {
        // let powRes = await this.bykApi.global.fGetSmMenuQx('修改下级代理')
        // if (!powRes) {
        //   return this.$message('暂无修改下级代理的权限');
        // }
        this.partnerAddOrEdit = "EDIT";
        let res = await this.fBykGetSubPartnerInfo(
          "PARTNER_PHONE",
          row.user_phone
        );

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        // this.parInfo = res.data[0];
        // this.parInfo.addSub =  this.can_add_sub_yn == 'Y' ? true :false

        this.frTableData = res.shop_pro_ledger

        this.parInfo.parPhone = res.data[0].user_phone; // 手机号
        this.parInfo.lxName = res.data[0].user_name; // 联系人
        this.parInfo.loginPwd = res.data[0].user_psw; // 登录密码
        this.parInfo.companyName = res.data[0].comp_name; // 公司名
        this.parInfo.serverIp = res.data[0].fwq_ip; // 服务器地址
        this.parInfo.industry = res.data[0].bus_type; // 所属行业
        this.parInfo.mainSale = res.data[0].bus_memo; // 主要经营
        this.parInfo.address = [
          res.data[0].shen,
          res.data[0].shi,
          res.data[0].qu,
        ]; // 门店地址
        this.parInfo.addrDetail = res.data[0].comp_address; // 详细地址
        this.parInfo.remarks = res.data[0].memo; // 备注
        this.parInfo.cooType = res.data[0].hz_way; // 合作方式
        this.parInfo.agentGrade = res.data[0].partner_level; // 代理等级
        this.parInfo.agentCost = res.data[0].pay_money || 0; // 代理费用
        this.parInfo.regNum = res.data[0].can_reg_user_num || 0; // 可注册用户数
        this.parInfo.expireTime = res.data[0].stop_time; // 失效时间
        this.parInfo.state = res.data[0].state; // 状态
        this.parInfo.comBase = res.data[0].partner_soft_price; // 提成基数
        this.parInfo.comType = res.data[0].partner_soft_tc_way; // 提成方式
        this.parInfo.comValue = res.data[0].partner_soft_tc_value; // 提成值

        this.parInfo.addSub = res.data[0].can_add_sub_yn == 'Y' ? true : false
        this.parInfo.addMallNum = res.data[0].can_add_mall == "Y" ? true : false; // 是否可增门店
        this.parInfo.isOem = res.data[0].oem_yn == "Y" ? true : false; // 是否OEM
        this.parInfo.isFree = res.data[0].free_yn == "Y" ? true : false; // 是否免费
        this.parInfo.partner_soft_fr_yn = res.data[0].partner_soft_fr_yn == "Y" ? true : false; 
        this.parInfo.shop_show_payqr_yn = res.data[0].shop_show_payqr_yn == "Y" ? true : false; 
        this.parInfo.editTime = res.data[0].can_chg_time == "Y" ? true : false; // 是否修改时间
        this.parInfo.homeUrl = res.data[0].main_url; // 主页网址
        // this.parInfo.customModule = res.data[0].  // 自定义模块
        this.parInfo.customMOduleUrl = res.data[0].shop_url; // 自定义模块网址
        this.parInfo.customMOduleAlsoOpenBrowser =
          res.data[0].shop_url_to_yn == "Y" ? true : false; // 自定义模块独立打开浏览器

        this.addOrEditAgent = true;
        if (this.bykApi.smCom.fSmIsEmpty(res.data[0].auth_info)) {
          this.checkAdministrationList = []
        } else {
          this.checkAdministrationList = JSON.parse(res.data[0].auth_info)
        }
        if (this.bykApi.smCom.fSmIsEmpty(res.data[0].pay_info)) {
          this.checkPayWayList = ['尚米PAY']
        } else {
          this.checkPayWayList = JSON.parse(res.data[0].pay_info)
        }
        // this.checkPayWayList=JSON.parse( res.data[0].pay_info)
      },
      async fSavePartner() {
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.parPhone)) {
          return this.$message("请输入手机号");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.lxName)) {
          return this.$message("请输入联系人");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.loginPwd)) {
          return this.$message("请输入登录密码");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.companyName)) {
          return this.$message("请输入公司名");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.serverIp)) {
          return this.$message("请输入服务器地址");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.industry)) {
          return this.$message("请输入所属行业");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.mainSale)) {
          return this.$message("请输入主要经营");
        }
        if (this.parInfo.address.length == 0) {
          return this.$message("请选择门店地址");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.addrDetail)) {
          return this.$message("请输入详细地址");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.cooType)) {
          return this.$message("请选择合作方式");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.agentGrade)) {
          return this.$message("请选择代理等级");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.agentCost)) {
          return this.$message("请输入代理费用");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.regNum)) {
          return this.$message("请输入可注册用户数");
        }
        // if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.expireTime)) {
        //   return this.$message("请选择失效时间");
        // }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.state)) {
          return this.$message("请选择状态");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.comBase)) {
          return this.$message("请输入提成基数");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.comType)) {
          return this.$message("请选择提成方式");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.comValue)) {
          return this.$message("请输入提成值");
        }
        // if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.isOem)) {
        //   return this.$message("请选择是否OEM");
        // }
        // if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.addMallNum)) {
        //   return this.$message("请选择是否可增加门店数");
        // }
        // if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.isFree)) {
        //   return this.$message("请选择是否免费");
        // }
        // if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.editTime)) {
        //   return this.$message("请选择是否修改时间");
        // }
        if (this.bykApi.smCom.fSmIsEmpty(this.parInfo.homeUrl)) {
          return this.$message("请输入主页网址");
        }

        //

        let res = await this.fBykPartnerManger(this.partnerAddOrEdit);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message(res.msg);
        this.init();
        this.fClose();
      },
      fClose() {
        this.frPop = false;
        this.frInfo = Object.assign({
          "user_phone": "",
          "partner_id": "",
          "soft_fr_now_money": "0",
          "user_name": "",
          "comp_name": "",
          "money": "0"
        });
        this.addOrEditAgent = false;
        this.active = '基本信息'
        this.checkAdministrationList = []
        this.checkPayWayList = []
        this.parInfo = Object.assign({
          parPhone: "", // 手机号
          lxName: "", // 联系人
          loginPwd: "", // 登录密码

          companyName: "", // 公司名
          serverIp: this.serverIp, // 服务器地址

          industry: "", // 所属行业
          mainSale: "", // 主要经营

          address: [], // 门店地址
          addrDetail: "", // 详细地址

          remarks: "", // 备注

          cooType: "按店付费", // 合作方式
          agentGrade: "D", // 代理等级
          agentCost: 39800, // 代理费用

          regNum: 0, // 可注册用户数
          expireTime: this.bykApi.timeHelper.manyDaysLater(365), // 失效时间
          state: "正常", // 状态

          comBase: '0', // 提成基数
          comType: "按比例值", // 提成方式
          comValue: '0', // 提成值

          addSub: false, // 是否可增下级
          addMallNum: false, // 是否可增门店
          isOem: false, // 是否OEM
          isFree: true, // 是否免费
          partner_soft_fr_yn: false, // 
          shop_show_payqr_yn: false, // 

          editTime: false, // 是否修改时间
          homeUrl: "http://www.sanmipos.com", // 主页网址

          customModule: "", // 自定义模块
          customMOduleUrl: "", // 自定义模块网址
          customMOduleAlsoOpenBrowser: false, // 自定义模块独立打开浏览器
          // checkAdministrationList: [],
          // checkPayWayList: [],
        });
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        //
        //
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },
      // 下拉框 change
      // fHeadTypeChange(e) {
      //   this.searchTypeVal = e[0];
      // },
      // 地址选择
      fHeadAddressChange(e) {
        this.shen = e[0];
        this.shi = e[1];
        this.qu = e[2];
        this.searchAddressVal = e[0] + "-" + e[1] + "-" + e[2];
      },
      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      // 提成值 change
      fComValueChange() {

        if (this.parInfo.comValue > 100) {
          this.parInfo.comValue = 100;
        } else if (this.parInfo.comValue < 0) {
          this.parInfo.comValue = 0;
        }
      },

      // 所属行业选择
      // fIndustryChange(e) {
      //
      // },

      // 地址选择
      fAddrChange(e) {
        // this.parInfo.address = e[0] + "-" + e[1] + "-" + e[2];
      },

      // 下拉框的通用 change 事件
      fCascaderChange(e, type, index) {
        console.log(e)
        if (type == "frComType") {
          this.frTableData[index].ledger_way = e[0]
          this.$forceUpdate()
          return
        }
        this.parInfo[type] = e[0];
        if (type == "comType") {
          this.parInfo.comBase = 0;
          this.parInfo.comValue = 0;
        }
      },

      async fRegPartner() {
        // let powRes = await this.bykApi.global.fGetSmMenuQx('新增下级代理')
        // if (!powRes) {
        //   return this.$message('暂无新增下级代理的权限');
        // }
        this.partnerAddOrEdit = "ADD";
        this.addOrEditAgent = true;

      },
      // 分页
      async fCurrentChange(e) {

        this.nowPage = e;
        let res = await this.fBykGetSubPartnerInfo(
          "PARTNER_LIST",
          this.merInputVal
        );

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      //计费模板
      fShowJfMb(item) {
        return this.$message('暂未开放');
        this.jfMbPop = true
      },
      fSaveJfMb() {

      },
      fAsideChoose(path, row) {
        this.eventBus.$emit('share', {});
        this.$router.push({
          path: path,
          query: {
            partnerId: row.user_phone
          }
        })
      },
      async fSaveJs() {
        if (this.bykApi.smCom.fSmIsEmpty(this.frInfo.money)) {
          return this.$message("本次结算金额不能为空");
        }
        // return
        let res = await this.fPartnerLedgerSettlement();
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.init();
        this.fClose();
      },
      // ------------- 请求 开始 --------------
      async fPartnerLedgerSettlement(oper) {
        let js = {};
        js["OPER"] = 'SETTLEMENT';
        js['USER_PHONE'] = this.frInfo.user_phone
        js['PAY_MONEY'] = this.frInfo.money
        js['REMARK'] = this.frInfo.remark
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_LEDGER_SETTLEMENT', js);
        console.log(res)
        return res;

      },
      // 获取下级列表信息
      async fBykGetSubPartnerInfo(oper, searchStr) {
        // let desc = "desc";
        // let field = "last_reg_time";
        let postJson = {};
        // postJson["METHOD_NAME"] = "GET_SUB_PARTNER_INFO";
        postJson["OPER"] = oper;
        postJson["PAGE_SIZE"] = 20;
        postJson["NOW_PAGE"] = this.nowPage;

        // if (this.searchSortVal == "最后注册时间升序") {
        //   desc = "asc";
        // } else if (this.searchSortVal == "已注册数降序") {
        //   field = "reg_user_num";
        // } else if (this.searchSortVal == "已注册数升序") {
        //   desc = "asc";
        //   field = "reg_user_num";
        // } else if (this.searchSortVal == "到期时间降序") {
        //   field = "stop_time";
        // } else if (this.searchSortVal == "到期时间升序") {
        //   desc = "asc";
        //   field = "stop_time";
        //   // } else if (this.searchSortVal == "支付分润降序") {
        //   //   field = "mall_count";
        //   // } else if (this.searchSortVal == "支付分润升序") {
        //   //   desc = "asc";
        //   //   field = "mall_count";
        //   // } else if (this.searchSortVal == "软件分润降序") {
        //   //   field = "online_zh_name";
        //   // } else if (this.searchSortVal == "软件分润升序") {
        //   //   desc = "asc";
        //   //   field = "online_zh_name";
        // } else if (this.searchSortVal == "等级降序") {
        //   field = "partner_level";
        // } else if (this.searchSortVal == "等级升序") {
        //   desc = "asc";
        //   field = "partner_level";
        // } else if (this.searchSortVal == "上级降序") {
        //   field = "p_user_name";
        // } else if (this.searchSortVal == "上级升序") {
        //   desc = "asc";
        //   field = "p_user_name";
        // } else if (this.searchSortVal == "今日活跃降序") {
        //   field = "day1_act_sh_count";
        // } else if (this.searchSortVal == "今日活跃升序") {
        //   desc = "asc";
        //   field = "day1_act_sh_count";
        // } else if (this.searchSortVal == "七日活跃降序") {
        //   field = "day7_act_sh_count";
        // } else if (this.searchSortVal == "七日活跃升序") {
        //   desc = "asc";
        //   field = "day7_act_sh_count";
        // }
        // postJson["ASC_DESC"] = desc;
        // postJson["ASC_DESC_FIELD"] = field;
        postJson["ASC_DESC"] = this.sortAscDesc;
        postJson["ASC_DESC_FIELD"] = this.sortType;
        postJson["SHEN"] = this.shen;
        postJson["SHI"] = this.shi;
        postJson["QU"] = this.qu;
        postJson["SEARCH_STR"] = searchStr;
        postJson["MH_YN"] = this.checked ? "Y" : "N";
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_PARTNER_INFO', postJson);
        console.log(res)
        return res;
      },
      // 修改 / 新增下级
      async fBykPartnerManger(oper) {
        let postJson = {};
        postJson["OPER"] = oper;
        postJson["PARTNER_LEVEL"] = this.parInfo.agentGrade; // 代理等级
        postJson["PARTNER_SOFT_PRICE"] = this.parInfo.comBase; // 提成基数
        postJson["PARTNER_SOFT_TC_WAY"] = this.parInfo.comType; // 提成方式
        postJson["PARTNER_SOFT_TC_VALUE"] = this.parInfo.comValue; // 提成值
        postJson["USER_PSW"] = this.parInfo.loginPwd; // 登录密码
        postJson["USER_NAME"] = this.parInfo.lxName; // 联系人
        postJson["USER_PHONE"] = this.parInfo.parPhone; // 手机号
        postJson["FWQ_IP"] = this.parInfo.serverIp; // 服务器地址
        postJson["CAN_REG_USER_NUM"] = this.parInfo.regNum; // 可注册用户数
        postJson["PAY_MONEY"] = this.parInfo.agentCost; // 代理费用
        postJson["COMP_NAME"] = this.parInfo.companyName; // 公司名
        postJson["SHEN"] = this.parInfo.address[0];
        postJson["SHI"] = this.parInfo.address[1];
        postJson["QU"] = this.parInfo.address[2];
        postJson["COMP_ADDRESS"] = this.parInfo.addrDetail; // 详细地址
        postJson["BUS_TYPE"] = this.parInfo.industry; // 所属行业
        postJson["BUS_MEMO"] = this.parInfo.mainSale; // 主要经营
        postJson["MEMO"] = this.parInfo.remarks; // 备注
        postJson["STATE"] = this.parInfo.state; // 状态
        postJson["HZ_WAY"] = this.parInfo.cooType; // 合作方式
        postJson["STOP_TIME"] = this.parInfo.expireTime; // 失效时间
        postJson["OEM_YN"] = this.parInfo.isOem ? "Y" : "N"; // 是否OEM
        postJson["FREE_YN"] = this.parInfo.isFree ? "Y" : "N"; // 是否免费
        postJson["CAN_CHG_TIME"] = this.parInfo.editTime ? "Y" : "N"; // 修改时间
        postJson["CAN_ADD_MALL"] = this.parInfo.addMallNum ? "Y" : "N"; // 是否可增门店
        postJson["CAN_ADD_SUB_PARTNER"] = this.parInfo.addSub ? "Y" : "N"; // 是否可增下级
        // postJson["CAN_ADD_MALL"] = this.parInfo.editSub ? "Y" : "N"; // 是否可修改下级

        postJson["PARTNER_SOFT_FR_YN"] = this.parInfo.partner_soft_fr_yn ? "Y" : "N"; // 商店分润
        postJson["SHOP_SHOW_PAYQR_YN"] = this.parInfo.shop_show_payqr_yn ? "Y" : "N"; // 商店显示收款二维码


        postJson["MAIN_URL"] = this.parInfo.homeUrl; // 主页网址
        postJson["SHOP_URL_TO_YN"] = this.parInfo.customMOduleAlsoOpenBrowser ?
          "Y" :
          "N"; // 自定义模块独立打开浏览器
        postJson["SHOP_URL"] = this.parInfo.customMOduleUrl; // 自定义模块网址
        postJson["AUTH_INFO"] = this.checkAdministrationList; // 自定义模块网址
        postJson["PAY_INFO"] = this.checkPayWayList; // 自定义模块网址

        postJson["SHOP_PRO_LEDGER"] = this.frTableData; // 分润设置





        console.log(postJson)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_MANGER', postJson);
        return res;
      },

      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .partner {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .active-title {
      color: #6396FC;
      border-bottom: 2px solid #6396FC;
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    // .dialog-title {
    //   line-height: 17px;
    //   font-size: 14px;
    //   padding-left: 8px;
    //   padding-bottom: 15px;
    //   border-bottom: 1px solid #e6e6e6;
    //   position: relative;
    //   &::after {
    //     content: "";
    //     display: flex;
    //     width: 3px;
    //     height: 14px;
    //     position: absolute;
    //     left: 0;
    //     top: 2px;
    //     border-left: 3px solid #2c6ff2;
    //   }
    // }
    /deep/ .add-dialog .el-dialog__body {
      padding: 2px 30px 20px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }
</style>



// WEBPACK FOOTER //
// src/view/partner.vue